
export type OrderStatusesType =
  'CREATED' |
  'PICKUP' |
  'PICKINGUP' |
  'PENDING_STORE_RECEPTION_VALIDATION' |
  'CLEANING' |
  'READY' |
  'DELIVERY' |
  'DELIVERING' |
  'COLLECTED' |
  'CANCELLED' |
  'UNCOLLECTED';

const OrderStatuses = {
  CREATED: 'created',
  PICKUP: 'pickup',
  PICKINGUP: 'pickingup',
  PENDING_STORE_RECEPTION_VALIDATION: 'pending_store_reception_validation',
  CLEANING: 'cleaning',
  READY: 'ready',
  DELIVERY: 'delivery',
  DELIVERING: 'delivering',
  COLLECTED: 'collected',
  CANCELLED: 'cancelled',
  UNCOLLECTED: 'uncollected'
};

Object.freeze(OrderStatuses);

export default OrderStatuses;
